import { Icons } from '@Assets/SvgIcons';
import { ComponentHelper } from '@Helper/Infra';
import {
  IconButton,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material';
import React, { FC, useState } from 'react';
import { useLocation } from 'react-router-dom';
import classes from '../TaskDetailModal.module.css';

type Props = {
  taskNumber: string;
};

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, title }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: title === 'Copied!' ? '#00875A' : '#0E0942',
    color: ' #F4F4F7;',
    width: 78,
    fontSize: 14,
    height: 25,
    borderRadius: 29,
    textAlign: 'center',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const CopyLinkButton: FC<Props> = ({ taskNumber }) => {
  const componentHelper = new ComponentHelper();
  const [isCopy, setIsCopy] = useState<boolean>(false);
  let location = useLocation();

  const setCopy = () => {
    componentHelper.unsecuredCopyToClipboard(
      window.location.origin + location.pathname + location.search
    );
    setIsCopy(true);
  };

  const onMouseOut = () => {
    if (isCopy) {
      setTimeout(() => {
        setIsCopy(false);
      }, 1000);
    }
  };

  return (
    <HtmlTooltip title={isCopy ? 'Copied!' : 'Copy link'} placement="top">
      <IconButton
        size="small"
        className={classes.headerIcon}
        onClick={setCopy}
        onMouseOut={onMouseOut}
      >
        <Icons.Link color="#6E6B8C" />
      </IconButton>
    </HtmlTooltip>
  );
};

export default CopyLinkButton;
